import { LoadingState } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";

export function LoadingCredentialsList() {
  const { t } = useTranslation();

  return (
    <LoadingState
      title={t("credentials.list.general.loading_credentials")}
      description={t("credentials.list.general.please_wait_while_we_load_the_credentials_for_you")}
    />
  );
}
